import { ROTULO_DO_PAPEL, type Papel } from '@/nucleo/auth/papeis';

import type {
  EntregaDoEmail,
  MetodoSegundoFator,
  SegundoFatorDaConta,
  SituacaoDoConvite,
  SituacaoDoUsuario,
} from './contrato';

/**
 * Textos do módulo de usuários. "Perfil de acesso" é o nome, na tela, do que o
 * código chama de papel (ordem U1, item 6).
 */

export function rotuloDoPerfil(codigo: string): string {
  return ROTULO_DO_PAPEL[codigo as Papel] ?? codigo;
}

export function rotuloDosPerfis(codigos: readonly string[]): string {
  return codigos.length === 0 ? 'Sem perfil de acesso' : codigos.map(rotuloDoPerfil).join(', ');
}

export const ROTULO_DA_SITUACAO: Record<SituacaoDoUsuario, string> = {
  ATIVO: 'Ativo',
  BLOQUEADO: 'Bloqueado',
  CONVITE_PENDENTE: 'Convite pendente',
  CONVITE_EXPIRADO: 'Convite expirado',
  CONVITE_EM_EMISSAO: 'Convite em emissão',
  CONVITE_COM_FALHA: 'Convite com falha',
};

/** Cor da situação: token semântico do selo (statusBadgeTokens). */
export const TOM_DA_SITUACAO: Record<
  SituacaoDoUsuario,
  'ativo' | 'bloqueado' | 'pendente' | 'expirado' | 'rejeitado'
> = {
  ATIVO: 'ativo',
  BLOQUEADO: 'bloqueado',
  CONVITE_PENDENTE: 'pendente',
  CONVITE_EXPIRADO: 'expirado',
  CONVITE_EM_EMISSAO: 'pendente',
  CONVITE_COM_FALHA: 'rejeitado',
};

export const ROTULO_DO_CONVITE: Record<SituacaoDoConvite, string> = {
  PENDENTE: 'Pendente',
  EXPIRADO: 'Expirado',
  ACEITO: 'Aceito',
  CANCELADO: 'Cancelado',
  FALHA: 'Não terminou de ser enviado',
  EM_EMISSAO: 'Em emissão',
};

export const ROTULO_DO_METODO: Record<MetodoSegundoFator, string> = {
  aplicativo: 'Aplicativo autenticador',
  email: 'Código por e-mail',
};

export function rotuloDoSegundoFator(valor: SegundoFatorDaConta): string {
  if (valor === 'nenhum') return 'Não cadastrado';
  if (valor === 'indisponivel') return 'Não foi possível consultar';
  return ROTULO_DO_METODO[valor];
}

const DATA_E_HORA = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeStyle: 'short',
  timeZone: 'America/Sao_Paulo',
});
const DATA = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeZone: 'America/Sao_Paulo',
});

export function dataEHora(iso: string | null | undefined): string {
  return iso ? DATA_E_HORA.format(new Date(iso)) : '—';
}

export function data(iso: string | null | undefined): string {
  return iso ? DATA.format(new Date(iso)) : '—';
}

/** Validade do link de troca de senha (a mesma do "Esqueci minha senha"). */
export const VALIDADE_DO_LINK_EM_MINUTOS = 30;

/**
 * O aviso quando o e-mail NÃO chega à pessoa neste ambiente. Nulo quando
 * chega. Não oferece outro caminho: a senha é sempre criada pela própria
 * pessoa, pelo link.
 */
export function avisoDeEntrega(entrega: EntregaDoEmail | null, destino: string): string | null {
  if (entrega === 'retido') {
    return `O e-mail não chega a ${destino}: o envio de e-mail está desligado neste ambiente.`;
  }
  if (entrega === 'caixa-de-testes') {
    return `O e-mail não chega a ${destino}: neste ambiente ele vai para a caixa de testes.`;
  }
  return null;
}
